import styled from 'styled-components';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-light-svg-icons';

import * as LayoutUtils from './utils';
import type { LayoutPanels, BaseContainer, Carousel, XmasPostsContainer } from './utils';
import { txt } from '../../../../locales/i18n';

const xmasPosts = [
	{
		title: 'Søger nogen  til juleaften',
		body: 'Jeg bor i Bylderupbov søger nogen at holde juleaften med ',
		image: 'new/20/img_1695886745075.jpg',
		type: 'guest',
	},
	{
		title: 'Skilsmisseforældre uden børn jul23',
		body: 'Er du ligesom jeg, uden dine børn juleaften, og skal igennem den aften uden at ryge i fosterstilling. Og! magter du heller ikke dine venners velmenende juleaften invitationer, da du så ha’ smasket deres lykkelige familieliv op i ansigtet, så er det nu, vi må stå sammen!!!!!🎄😅 🤗\n… jeg forestiller mig, at vi kan samles en 6-8 stykker- begge køn er velkomne. Være fælles om at lave og spise god julemad. Og herefter lave nogle drinks. Evt en træls pakkeleg fordi det hører sig til🤷‍♀️🤦🏼‍♀️🎁\nAlder 40-50 år. Sammen klarer vi den👏🏻👊🏻',
		image: 'new/579206/img_1694889585442.jpg',
		type: 'host',
	},
	{
		title: 'Nogle at holde jul med',
		body: 'Hejsa\nJeg søger nogle at holde jul med, min resterende familie er splittet op og bor for langt væk, vil sige Sjælland og jeg selv i Vejle, så jeg søger nogle, hvor det muligvis kunne blive en tradition, men ingen forpligtelse, kun et ønske herfra i forhold til forudsigelighed. Jeg har ikke nogle traditioner og noget der skal være, kun at jeg ikke skal sidde alene ',
		image: 'new/169872/img_1694272250411.jpg',
		type: 'guest',
	},
	{
		title: 'Lille familie på 4',
		body: 'Da vi ikke holder jul med vores familie hvert 2 år er vi blevet enige om at åbne vores dør for nogle der er ensomme og ikke skal holde jul selv.  Vi har stor hund og kat og bor på landet. Men kan hente såfrem i bor i Haderslev området.',
		image: 'new/20/img_1695798986048.jpg',
		type: 'host',
	},
];

export const xmasPostsLayoutPanels: LayoutPanels = {
	layoutName: txt('cms.layoutNames.xmas posts'),
	panels: [
		{
			label: txt('cms.panelNames.layout container'),
			formKey: 'container',
			type: 'baseContainerPanel',
		},

		{
			label: txt('cms.panelNames.carousel'),
			formKey: 'carousel',
			type: 'carouselPanel',
		},

		{
			label: txt('cms.panelNames.posts'),
			formKey: 'posts',
			type: 'xmasPostsPanel',
		},
	],
};

type XmasPostsLayoutProps = {
	container: BaseContainer;
	carousel: Carousel;
	posts: XmasPostsContainer;
};

export const XmasPostsLayoutValues: XmasPostsLayoutProps = {
	container: LayoutUtils.defaultBaseContainer,
	carousel: { arrowColor: '#2a6592' },
	posts: { titleColor: '#333333', textColor: '#333333' },
};

export const XmasPostsLayout = (props: XmasPostsLayoutProps) => {
	const renderXmasPost = (post: any) => (
		<div key={post.id}>
			<div className="post-container">
				<div className="image-container">
					<img
						className="xmas-image"
						alt="xmas detail"
						src={
							post.type === 'host'
								? '/images/julehus-sign.png'
								: '/images/julekrans-sign.png'
						}
					/>

					<img
						className={
							post.type === 'host'
								? 'post-image host-image'
								: 'post-image guest-image'
						}
						alt="xmas post"
						src={'https://filer.boblberg.dk/Img/Julevenner/' + post.image}
					/>
				</div>

				<h3>{post.title}</h3>
				<p>{post.body}</p>
			</div>
		</div>
	);

	return (
		<XmasPostsLayoutPreviewStyled styledProps={props}>
			<div className="carousel-container">
				<FontAwesomeIcon size="2x" icon={faChevronLeft} className="arrow-icon" />
				{xmasPosts.map(renderXmasPost)}
				<FontAwesomeIcon size="2x" icon={faChevronRight} className="arrow-icon" />
			</div>
		</XmasPostsLayoutPreviewStyled>
	);
};

const XmasPostsLayoutPreviewStyled = styled.div<{ styledProps: XmasPostsLayoutProps }>`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-wrap: wrap;
	padding: 3em;
	gap: 2rem;
	background-color: ${({ styledProps }) => styledProps.container.backgroundColor};
	min-height: ${({ styledProps }) => (styledProps.container.fullscreen ? '100dvh' : 'auto')};

	background-size: cover;
	background-position: center;
	background-image: ${({ styledProps }) => {
		if (styledProps.container.coverSource === '') return 'none';
		return `url(${LayoutUtils.getImageSource(styledProps.container.coverSource)})`;
	}};

	.slick-prev {
		left: 0;
	}

	.slick-next {
		right: 0;
	}

	.slick-arrow {
		z-index: 1;
		padding: 1rem;
		font-size: 15px;
		height: auto;

		&::before {
			content: '';
		}
	}

	.carousel-container {
		max-width: 1200px;
		margin-inline: auto;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 1rem;

		.arrow-icon {
			color: ${({ styledProps }) => styledProps.carousel.arrowColor};
		}
	}

	.post-container {
		box-sizing: border-box;
		width: 240px;
		aspect-ratio: 3/4;
		margin-inline: auto;
		font-size: 15px;

		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 6px;

		.image-container {
			position: relative;

			img {
				height: 200px;
				aspect-ratio: 1;
			}

			.post-image {
				box-sizing: border-box;
				border-radius: 100%;
				padding: 1rem;
			}

			.host-image {
				padding: 1.4rem;
				padding-bottom: 0.4rem;
			}

			.xmas-image {
				position: absolute;
			}
		}

		h3 {
			margin: 0;
			display: -webkit-box;
			-webkit-line-clamp: 1;
			-webkit-box-orient: vertical;
			overflow: hidden;
			color: ${({ styledProps }) => styledProps.posts.titleColor};
		}

		p {
			margin: 0;
			display: -webkit-box;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;
			overflow: hidden;
			color: ${({ styledProps }) => styledProps.posts.textColor};
		}
	}
`;
